import React, { useState, useEffect, useContext } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import * as Sentry from "@sentry/react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Typography from "@material-ui/core/Typography";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import styled from "styled-components";
import FileSaver, { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";

import {
  Box,
  Button,
  Checkbox,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import TabSearchbar from "../../components/TabSearchbar/index.js";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
  DateRangePicker,
} from "@material-ui/pickers";
import { MdContentCopy } from "react-icons/md";
// import { CSVLink } from "react-csv";
import { ExportToCsv } from "export-to-csv";
import { CoinContext } from "../../contexts/CoinContext";
import { iconsDict } from "../../assets/icons/iconsDict.js";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import exportLight from "../../assets/img/export_icon-light.png";
import exportDark from "../../assets/img/export_icon-dark.png";

import { REACT_APP_PROD_URL } from "../../services/configs";
import { abbriDict } from "../../assets/icons/abbriDict.js";
import useResizer from "../../services/useResizer.js";
import TransactionCard from "../../components/TransactionCard/index.js";
import { debounce } from "lodash";
import { format, isValid } from "date-fns";
import { useSelector } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import fetcher from "../../api/swr_fetcher.js";
import { copyTextAndSendToApp } from "../../services/appMethods.js";
import { notifyApp } from "../../services/notifyApp.js";

export default function Transactions() {
  const isMobile = useResizer();
  const token = useSelector((state) => state.trading.TOKEN);

  const { handleClickAlert, bannedTimeout } = useContext(CoinContext);
  const darkMode = useSelector((state) => state.trading.DARK_MODE);

  function formatData(
    side,
    type,
    searchText,
    fromDate,
    toDate,
    filterType,
    total = 999
  ) {
    var allTrans = [];
    let filter;
    if (filterType === "keyword" || filterType === "Asset") {
      filter = `&searchId=${searchText}&side=${side}marketType=${type}&status=&startDate=&endDate=&`;
    } else {
      if (isValid(fromDate) && isValid(toDate)) {
        let start = fromDate
          .toISOString()
          .replace(/T.*/, "")
          .split("-")
          .reverse()
          .join("-");
        let end = toDate
          .toISOString()
          .replace(/T.*/, "")
          .split("-")
          .reverse()
          .join("-");
        filter = `&searchId=&side=&marketType=&status=&startDate=${start}&endDate=${end}`;
      }
    }
    fetcher(
      `/v1/um/getAllTransactions?sortBy=createdAt&direction=DESC&page=1&pageSize=${total}${filter}`
    )
      .then((data) => {
        if (data.status) {
          allTrans = null;
          handleClickAlert("error", "Request failed");
        } else {
          allTrans = data;

          // csvExporter.generateCsv(allTrans.content);
          var headers = [
            [
              "Created At",
              "Updated At",
              "Side",
              "Coin",
              "Type",
              "Quantity",
              "Price",
              "TDS",
              "Total Amount",
              "Status",
            ],
          ];
          var headersNonIos = {
            createdAt: "Created At",
            updatedAt: "Updated At",
            side: "Side",
            coin: "Coin",
            type: "Type",
            quantity: "Quantity",
            price: "Price",
            tds: "TDS",
            totalAmount: "Total Amount",
            status: "Status",
          };
          let itemsFormatted = [];
          allTrans.content.forEach((item) => {
            itemsFormatted.push({
              createdAt: format(
                new Date(item.createdAt),
                "dd.MM.yy hh:mm:ss aaaaa'm'"
              ),
              updatedAt: format(
                new Date(item.updatedAt),
                "dd.MM.yy hh:mm:ss aaaaa'm'"
              ),
              side: item.side,
              coin: item.coin,
              type: item.type,
              quantity: item.quantity,
              price: item.price,
              tds: item.tds,
              totalAmount: item.totalAmount,
              status: item.status,
            });
          });
          let filename =
            "PocketBits_Transactions_" +
            String(format(new Date(Date.now()), "ddMMyy_HHmm"));
          var jsonObject = JSON.stringify(itemsFormatted);
          var csv = convertToCSV(jsonObject);
          var title = "My Transactions";

          if (getMobileOperatingSystem() == "iOS") {
            toast("Allow popups in iOS to view transaction reports as PDF", {
              duration: 4000,
              icon: "ℹ️",
              style: {
                borderRadius: "10px",
                background: darkMode ? "#fff" : "#222",
                color: darkMode ? "#222" : "#fff",
              },
            });
            exportPDF(itemsFormatted, title, filename, headers);

            return;
          }

          exportCSVFile(headersNonIos, itemsFormatted, filename);
        }
      })
      .catch((err) => {
        console.error(err);
        console.error(err);
      });
  }
  const exportPDF = (values, title, filename, headers) => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const data = values.map((item) => [
      item.createdAt,
      item.updatedAt,
      item.side,
      item.coin,
      item.type,
      item.quantity,
      item.price,
      item.tds,
      item.totalAmount,
      item.status,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);

    // window.open(doc.output("bloburl"), "_blank");
    window.open(doc.output("bloburl", { filename: filename + ".pdf" }));
  };
  function convertToCSV(objArray) {
    var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    var str = "";

    for (var i = 0; i < array.length; i++) {
      var line = "";
      for (var index in array[i]) {
        if (line != "") line += ",";

        line += array[i][index];
      }

      str += line + "\r\n";
    }

    return str;
  }
  /* Helper function */

  function exportCSVFile(headers, items, fileTitle) {
    if (headers) {
      items.unshift(headers);
    }

    // Convert Object to JSON
    // console.log(items);
    var jsonObject = JSON.stringify(items);

    var csv = convertToCSV(jsonObject);

    var exportedFilename = fileTitle + ".csv" || "export.csv";

    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, exportedFilename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("target", "_blank");
        link.setAttribute("download", exportedFilename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    toast.success("Transactions CSV exported", { duration: 3000 });
  }

  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }

  function formatDataRN(
    side,
    type,
    searchText,
    fromDate,
    toDate,
    filterType,
    total = 999
  ) {
    var allTrans = [];
    let filter;
    if (filterType === "keyword" || filterType === "Asset") {
      filter = `&searchId=${searchText}&side=${side}marketType=${type}&status=&startDate=&endDate=&`;
    } else {
      if (isValid(fromDate) && isValid(toDate)) {
        let start = fromDate
          .toISOString()
          .replace(/T.*/, "")
          .split("-")
          .reverse()
          .join("-");
        let end = toDate
          .toISOString()
          .replace(/T.*/, "")
          .split("-")
          .reverse()
          .join("-");
        filter = `&searchId=&side=&marketType=&status=&startDate=${start}&endDate=${end}`;
      }
    }
    fetcher(
      `/v1/um/getAllTransactions?sortBy=createdAt&direction=DESC&page=1&pageSize=${total}${filter}`
    )
      .then((data) => {
        if (data.status) {
          allTrans = null;
          handleClickAlert("error", "Request failed");
        } else {
          allTrans = data;

          // csvExporter.generateCsv(allTrans.content);
          var headers = [
            [
              "Created At",
              "Updated At",
              "Side",
              "Coin",
              "Type",
              "Quantity",
              "Price",
              "TDS",
              "Total Amount",
              "Status",
            ],
          ];
          var headersNonIos = {
            createdAt: "Created At",
            updatedAt: "Updated At",
            side: "Side",
            coin: "Coin",
            type: "Type",
            quantity: "Quantity",
            price: "Price",
            tds: "TDS",
            totalAmount: "Total Amount",
            status: "Status",
          };
          let itemsFormatted = [];
          allTrans.content.forEach((item) => {
            itemsFormatted.push({
              createdAt: format(
                new Date(item.createdAt),
                "dd.MM.yy hh:mm:ss aaaaa'm'"
              ),
              updatedAt: format(
                new Date(item.updatedAt),
                "dd.MM.yy hh:mm:ss aaaaa'm'"
              ),
              side: item.side,
              coin: item.coin,
              type: item.type,
              quantity: item.quantity,
              price: item.price,
              tds: item.tds,
              totalAmount: item.totalAmount,
              status: item.status,
            });
          });
          let filename =
            "PocketBits_Transactions_" +
            String(format(new Date(Date.now()), "ddMMyy_HHmm"));
          var jsonObject = JSON.stringify(itemsFormatted);
          var csv = convertToCSV(jsonObject);
          var title = "My Transactions";

          if (getMobileOperatingSystem() == "iOS") {
            toast("Allow popups in iOS to view transaction reports as PDF", {
              duration: 4000,
              icon: "ℹ️",
              style: {
                borderRadius: "10px",
                background: darkMode ? "#fff" : "#222",
                color: darkMode ? "#222" : "#fff",
              },
            });

            return;
          }
          notifyApp({
            type: "DOWNLOAD",
            data: { headersNonIos, itemsFormatted, filename },
          });
        }
      })
      .catch((err) => {
        console.error(err);
        console.error(err);
      });
  }

  return (
    <>
      {isMobile ? (
        <TransactionsMobile downloadCSV={formatData} formatDataRN={formatDataRN}></TransactionsMobile>
      ) : (
        <TransactionsDesktop downloadCSV={formatData}></TransactionsDesktop>
      )}
    </>
  );
}

function TransactionsDesktop(props) {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();
  const token = useSelector((state) => state.trading.TOKEN);

  const statusDict = {
    FILLED: "COMPLETED",
    FAILED: "REJECTED",
    IN_PROGRESS: "PENDING",
    AWAITING_ADMIN_ACTION: "PENDING",
    AWAITING_USER_VERIFICATION: "UNVERIFIED",
    APPROVED_BY_ADMIN: "SUCCESS",
    PROCESSED_BY_ADMIN: "SUCCESS",
    REJECTED_BY_ADMIN: "REJECTED",
  };

  const darkStatusColor = {
    SUCCESS: "#C1F4D8",
    FILLED: "#C1F4D8",
    COMPLETED: "#C1F4D8",
    FAILED: "#fed9d9",
    CANCELLED: "#fed9d9",
    IN_PROGRESS: "#fefcd9",
    PENDING: "#fefcd9",
    AWAITING_ADMIN_ACTION: "#fefcd9",
    AWAITING_USER_VERIFICATION: "#fefcd9",
    APPROVED_BY_ADMIN: "#C1F4D8",
    PROCESSED_BY_ADMIN: "#C1F4D8",
    REJECTED_BY_ADMIN: "#fed9d9",
  };

  const darkStatusBackground = {
    SUCCESS: "#20581f",
    FILLED: "#20581f",
    COMPLETED: "#20581f",
    FAILED: "#581f1f",
    CANCELLED: "#581f1f",
    IN_PROGRESS: "#58571f",
    PENDING: "#58571f",
    AWAITING_ADMIN_ACTION: "#58571f",
    AWAITING_USER_VERIFICATION: "#58571f",
    APPROVED_BY_ADMIN: "#20581f",
    PROCESSED_BY_ADMIN: "#20581f",
    REJECTED_BY_ADMIN: "#581f1f",
  };

  const lightStatusColor = {
    SUCCESS: "#37a609",
    FILLED: "#37a609",
    COMPLETED: "#37a609",
    FAILED: "#ff5f5f",
    CANCELLED: "#ff5f5f",
    IN_PROGRESS: "#ffd95f",
    PENDING: "#ffd95f",
    AWAITING_ADMIN_ACTION: "#ffd95f",
    AWAITING_USER_VERIFICATION: "#ffd95f",
    APPROVED_BY_ADMIN: "#37a609",
    PROCESSED_BY_ADMIN: "#37a609",
    REJECTED_BY_ADMIN: "#ff5f5f",
  };

  const [tradeHistory, setTradeHistory] = useState(null);
  const [inrTrans, setInrTrans] = useState(null);

  const [type, setType] = useState("&");
  const [side, setSide] = useState("&");
  const [searchText, setSearchText] = useState("");
  const [checked, setChecked] = React.useState(false);
  const [filteredTradeData, setFilteredTradeData] = useState(null);

  // const [fromDate, setFromDate] = useState(new Date("2020-10-01T21:11:54"));
  // const [toDate, setToDate] = useState(new Date("2020-10-31T21:11:54"));
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  // console.log(typeof fromDate, toDate);

  const { handleClickAlert, bannedTimeout } = useContext(CoinContext);

  // for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // for toggle button
  const [filterType, setFilterType] = useState("keyword");

  const handleToggleChange = (event, newFilter) => {
    // if (checked) {
    //   setChecked(false);
    // }
    if (newFilter !== null) {
      setFilterType(newFilter);
    }
  };

  // for transaction id
  const [transId, setTransId] = useState(null);

  useEffect(() => {
    if (token) {
      var bearer = "Bearer " + token;
      var filterStr;

      if (filterType === "keyword") {
        filterStr = `&searchId=${
          abbriDict[searchText.toLowerCase()]
            ? abbriDict[searchText.toLowerCase()]
            : searchText.toUpperCase()
        }&side=${side}marketType=${type}status=&startDate=&endDate=&`;
      } else {
        if (isValid(fromDate) && isValid(toDate)) {
          let start = fromDate
            .toISOString()
            .replace(/T.*/, "")
            .split("-")
            .reverse()
            .join("-");
          let end = toDate
            .toISOString()
            .replace(/T.*/, "")
            .split("-")
            .reverse()
            .join("-");
          filterStr = `&searchId=&side=&marketType=&status=&startDate=${start}&endDate=${end}`;
        }
      }
      // } else {
      //   filterStr = `&searchId=&side=&marketType=&status=&startDate=&endDate=&`;
      // }

      fetcher(
        `/v1/um/getAllTransactions?sortBy=createdAt&direction=DESC&page=${
          page + 1
        }&pageSize=${rowsPerPage}` + filterStr
      )
        .then((data) => {
          if (data.status) {
            setTradeHistory(null);
            // holdBal = [];
            // mergeInr(holdBal);
          } else {
            // console.log(data);
            setTradeHistory(data);
            // holdBal = data;
            // mergeInr(holdBal);
          }
        })
        .catch((err) => {
          console.error(err);
          // console.error(err);
        });
      // console.log("Getting trading history (orders)");
    }
  }, [
    page,
    rowsPerPage,
    checked,
    side,
    type,
    searchText,
    filterType,
    fromDate,
    toDate,
  ]);

  // const dynamicTrade = checked ? filteredTradeData : tradeHistory;

  const handleFromDateChange = (date) => {
    setFromDate(date);
    setPage(0);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
    setPage(0);
  };

  // export to excel/csv
  const options = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    showTitle: true,
    title: "My Transactions",
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: "pocketBits_transactions",
    // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
  };

  return (
    <div className={classes.root}>
      <h1 className="mb-5">Transactions</h1>

      <div className={classes.paddedContainer}>
        <div className={classes.filterContainer}>
          <ToggleButtonGroup
            orientation="vertical"
            value={filterType}
            exclusive
            onChange={handleToggleChange}
            style={{ marginRight: "20px" }}
          >
            <ToggleButton
              value="keyword"
              aria-label="keyword"
              style={{ fontSize: "11px" }}
            >
              Filter by assets
            </ToggleButton>
            <ToggleButton
              value="date"
              aria-label="date"
              style={{ fontSize: "11px" }}
            >
              Filter by date
            </ToggleButton>
          </ToggleButtonGroup>

          {filterType === "keyword" ? (
            <div className={classes.subContainer}>
              <div className={classes.searchContainer}>
                <TabSearchbar
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                />
              </div>

              <FormControl variant="outlined" className={classes.dropDownType}>
                <Select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                  }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={type}
                  onChange={(event) => {
                    setType(event.target.value);
                    setPage(0);
                  }}
                >
                  <MenuItem value="&" style={{ minWidth: "80px !important" }}>
                    All types
                  </MenuItem>
                  <MenuItem value="MARKET&" style={{ minWidth: "80px" }}>
                    Market
                  </MenuItem>
                  <MenuItem value="LIMIT&" style={{ minWidth: "80px" }}>
                    Limit
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl variant="outlined" className={classes.dropDownSide}>
                <Select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                  }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={side}
                  onChange={(event) => {
                    setSide(event.target.value);
                    setPage(0);
                  }}
                >
                  <MenuItem value="&" style={{ minWidth: "80px !important" }}>
                    All sides
                  </MenuItem>
                  <MenuItem value="BUY&" style={{ minWidth: "80px" }}>
                    Buy
                  </MenuItem>
                  <MenuItem value="SELL&" style={{ minWidth: "80px" }}>
                    Sell
                  </MenuItem>
                  <MenuItem value="DEPOSIT&" style={{ minWidth: "80px" }}>
                    Deposit
                  </MenuItem>
                  <MenuItem value="WITHDRAW&" style={{ minWidth: "80px" }}>
                    Withdraw
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
          ) : (
            <div className={classes.subContainer}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="start"
                  label="Start"
                  value={fromDate}
                  onChange={handleFromDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  maxDate={new Date()}
                />
                <p style={{ margin: "20px", fontSize: "16px" }}>To</p>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="end"
                  label="End"
                  value={toDate}
                  onChange={handleToDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  minDate={fromDate}
                  maxDate={new Date()}
                />
              </MuiPickersUtilsProvider>
            </div>
          )}

          {/* <div style={{ display: "flex", alignItems: "center" }}>
            <Checkbox
              checked={checked}
              onChange={(event) => {
                setPage(0);
                setChecked(event.target.checked);
              }}
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
            <p>Apply filters</p>
          </div> */}
        </div>

        <div className={classes.excelContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              props.downloadCSV(
                side,
                type,
                searchText.toUpperCase(),
                fromDate,
                toDate,
                filterType,
                tradeHistory.totalElements
              )
            }
            className={classes.excelButton}
          >
            {/* <CSVLink
              data={tradeHistory ? tradeHistory : "loading"}
              filename={"simran"}
            >
              Export to excel
            </CSVLink> */}
            Export to excel
          </Button>
        </div>
        <div className={classes.tableRoot}>
          <TableContainer component="div" style={{ maxHeight: "700px" }}>
            <Table
              className={classes.table}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead className={classes.tableHeadText}>
                <TableRow>
                  <TableCell className={classes.headerCell} align="left">
                    REQUEST DATE
                  </TableCell>
                  <TableCell className={classes.headerCell} align="left">
                    COIN
                  </TableCell>
                  <TableCell className={classes.headerCell} align="left">
                    TYPE
                  </TableCell>
                  <TableCell className={classes.headerCell} align="left">
                    SIDE
                  </TableCell>
                  <TableCell className={classes.headerCell} align="left">
                    QUANTITY
                  </TableCell>

                  <TableCell className={classes.headerCell} align="left">
                    PRICE
                  </TableCell>
                  <TableCell className={classes.headerCell} align="left">
                    TDS
                  </TableCell>
                  <TableCell className={classes.headerCell} align="left">
                    TOTAL AMOUNT
                  </TableCell>
                  <TableCell className={classes.headerCell} align="left">
                    STATUS
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tradeHistory
                  ? tradeHistory.content
                    ? tradeHistory.content.map((row) => (
                        <TableRow
                          key={row.orderId}
                          className={classes.bodyRows}
                        >
                          <TableCell
                            align="left"
                            className={classes.bodyTextStyles}
                          >
                            {row.updatedAt
                              ? `${row.updatedAt.slice(
                                  8,
                                  10
                                )}.${row.updatedAt.slice(
                                  5,
                                  7
                                )}.${row.updatedAt.slice(
                                  0,
                                  4
                                )} ${row.updatedAt.slice(11, 16)}`
                              : row.createdAt
                              ? `${row.createdAt.slice(
                                  8,
                                  10
                                )}.${row.createdAt.slice(
                                  5,
                                  7
                                )}.${row.createdAt.slice(
                                  0,
                                  4
                                )} ${row.createdAt.slice(11, 16)}`
                              : "-"}
                          </TableCell>
                          <TableCell
                            className={classes.bodyTextStyles}
                            align="left"
                          >
                            {row.coin}
                          </TableCell>
                          <TableCell
                            className={classes.bodyTextStyles}
                            align="left"
                          >
                            {row.type ? row.type : "-"}
                          </TableCell>
                          <TableCell
                            className={classes.bodyTextStyles}
                            align="left"
                            style={{
                              color:
                                row.side === "BUY" || row.side === "DEPOSIT"
                                  ? "#3AC4AB"
                                  : "#DE565E",
                              fontWeight: "bold",
                            }}
                          >
                            {row.side}
                          </TableCell>
                          <TableCell
                            className={classes.bodyTextStyles}
                            align="left"
                          >
                            {row.quantity ? row.quantity : "-"}
                          </TableCell>

                          <TableCell
                            className={classes.bodyTextStyles}
                            align="left"
                          >
                            {row.price ? row.price : "-"}
                          </TableCell>
                          <TableCell
                            className={classes.bodyTextStyles}
                            align="left"
                          >
                            {typeof row.tds !== "undefined" && row.tds !== null
                              ? row.tds > 0
                                ? "- " + row.tds
                                : row.tds
                              : "-"}
                          </TableCell>
                          <TableCell
                            className={classes.bodyTextStyles}
                            align="left"
                          >
                            {Math.floor(row.finalAmount * 100) / 100}
                          </TableCell>
                          <TableCell
                            className={classes.bodyTextStyles}
                            align="center"
                          >
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  background:
                                    theme.palette.type === "dark"
                                      ? darkStatusBackground[row.status]
                                      : darkStatusColor[row.status],
                                  // width: "115px",
                                  fontWeight: "bold",
                                  color:
                                    theme.palette.type === "dark"
                                      ? darkStatusColor[row.status]
                                      : lightStatusColor[row.status],
                                  width: "150px",
                                  wordBreak: "break-all",
                                  borderRadius: "20px",
                                  padding: "2px",
                                  fontSize: "12px",
                                }}
                              >
                                {statusDict[row.status]
                                  ? statusDict[row.status]
                                  : row.status}
                              </div>
                              {row.status === "SUCCESS" &&
                              row.side === "WITHDRAW" &&
                              row.coin !== "INR" ? (
                                <Tooltip
                                  title="copy transaction ID"
                                  placement="right"
                                >
                                  <IconButton
                                    style={{ padding: 0, marginLeft: "10px" }}
                                    className={classes.copyIcon}
                                    onClick={() => {
                                      navigator.clipboard.writeText(row.id);
                                      copyTextAndSendToApp(row.id);

                                      handleClickAlert(
                                        "success",
                                        "Transaction ID Copied!"
                                      );
                                    }}
                                  >
                                    {/* <InfoOutlinedIcon fontSize="small" /> */}
                                    <MdContentCopy />
                                  </IconButton>
                                </Tooltip>
                              ) : null}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    : null
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={tradeHistory ? tradeHistory.totalElements : 10}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}
function TransactionsMobile(props) {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [tradeHistory, setTradeHistory] = useState([]);
  const [type, setType] = useState("&");
  const [side, setSide] = useState("&");
  const [filterType, setFilterType] = useState("Asset");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const token = useSelector((state) => state.trading.TOKEN);
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);

  useEffect(() => {
    fetchTransactions(true);
  }, []);

  const debounceOnChange = React.useCallback(
    debounce(fetchTransactions, 1000),
    []
  );
  const isTransactionsAvailable = Boolean(tradeHistory?.content);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  function fetchTransactions(
    initial = false,
    searchText = "",
    page = 0,
    rowsPerPage = 10,
    type = "&",
    side = "&",
    fromDate = "&",
    endDate = "&"
  ) {
    // console.log("called");
    let filterStr = "";
    let from =
      isValid(fromDate) &&
      fromDate !== "&" ?
      format(new Date(fromDate), "dd-MM-yyyy"):""
    let end =
      isValid(toDate) &&
      endDate !== "&" ?
      format(new Date(endDate), "dd-MM-yyyy"):""
    if (from == "01-01-1970") {
      from = "&";
    }
    if (end == "01-01-1970") {
      end = "&";
    }
    console.log(fromDate,from,end,"date")
    if (initial == true) {
      filterStr = "&searchId=&side=&marketType=&status=&startDate=&endDate=&";
    } else {
      filterStr = `&searchId=${
        abbriDict[searchText.toLowerCase()]
          ? abbriDict[searchText.toLowerCase()]
          : searchText.toUpperCase()
      }&side=${side}marketType=${type}status=&startDate=${from}&endDate=${end}`;
    }

    fetcher(
      `/v1/um/getAllTransactions?sortBy=createdAt&direction=DESC&page=${
        page + 1
      }&pageSize=${rowsPerPage}` + filterStr
    )
      .then((data) => {
        setTradeHistory(data);
      })
      .catch((err) => {
        console.error(err);
        // console.error(err);
      });
  }

  useEffect(() => {
    if (isTransactionsAvailable) {
      debounceOnChange(
        false,
        searchText,
        page,
        rowsPerPage,
        type,
        side,
        fromDate,
        toDate
      );
    }
  }, [searchText]);

  useEffect(() => {
    let fromDateSanitized = fromDate;
    let toDateSanitized = toDate;
    // console.log(fromDate == "01-01-1970");
    // if (isTransactionsAvailable) {

    if (isTransactionsAvailable) {
      fetchTransactions(
        false,
        searchText,
        page,
        rowsPerPage,
        type,
        side,
        fromDate,
        toDate
      );
    }
  }, [page, rowsPerPage, type, side, fromDate, toDate]);

  function onSearchMobile(e) {
    let searchText = e.target.value;
    setSearchText(searchText);
    setPage(0);
  }

  return (
    <div>
      <div className={classes.root}>
        <div className="flex justify-between items-center mb-5">
          <h1 className="">Transactions</h1>
          <div>
            <img
              src={darkMode ? exportDark : exportLight}
              width={"24px"}
              onClick={() => {
                if (window && window.ReactNativeWebView) {
                  props.formatDataRN(
                    side,
                    type,
                    searchText.toUpperCase(),
                    fromDate,
                    toDate,
                    filterType,
                    tradeHistory.totalElements
                  );
                } else {
                  props.downloadCSV(
                    side,
                    type,
                    searchText.toUpperCase(),
                    fromDate,
                    toDate,
                    filterType,
                    tradeHistory.totalElements
                  );
                }
              }}
            ></img>
          </div>
        </div>
        <div className="mb-4">
          <div
            className="flex items-center justify-between
           "
          >
            <ToggleSwitch
              values={["Asset", "Date"]}
              selected={filterType}
              className="mr-5"
              darkMode={darkMode}
              onChange={(val) => {
                setFilterType(val);
                if (val == "Date") {
                  setType("&");
                  setSide("&");
                } else {
                  setFromDate(null);
                  setToDate(null);
                }
              }}
            />
            {/* <ToggleButtonGroup
              orientation="horizontal"
              value={filterType}
              exclusive
              onChange={handleToggleChange}
              style={{ marginRight: "20px" }}
            >
              <ToggleButton
                value="keyword"
                aria-label="keyword"
                style={{ fontSize: "11px" }}
              >
                Asset
              </ToggleButton>
              <ToggleButton
                value="date"
                aria-label="date"
                style={{ fontSize: "11px" }}
              >
                Date
              </ToggleButton>
            </ToggleButtonGroup> */}

            <div className="flex justify-end">
              {filterType == "Asset" && (
                <>
                  <FormControl className={classes.dropDownType}>
                    <Select
                      classes={{
                        root: classes.rootSelect,
                        icon: classes.icon,
                      }}
                      disableUnderline
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={type}
                      onChange={(event) => {
                        setType(event.target.value);
                        setPage(0);
                      }}
                    >
                      <MenuItem
                        value="&"
                        style={{ minWidth: "80px !important" }}
                      >
                        All types
                      </MenuItem>
                      <MenuItem value="MARKET&" style={{ minWidth: "80px" }}>
                        Market
                      </MenuItem>
                      <MenuItem value="LIMIT&" style={{ minWidth: "80px" }}>
                        Limit
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl className={classes.dropDownType}>
                    <Select
                      classes={{
                        root: classes.rootSelect,
                        icon: classes.icon,
                      }}
                      disableUnderline
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={side}
                      onChange={(event) => {
                        setSide(event.target.value);
                        setPage(0);
                      }}
                    >
                      <MenuItem
                        value="&"
                        style={{ minWidth: "80px !important" }}
                      >
                        All sides
                      </MenuItem>
                      <MenuItem value="BUY&" style={{ minWidth: "80px" }}>
                        Buy
                      </MenuItem>
                      <MenuItem value="SELL&" style={{ minWidth: "80px" }}>
                        Sell
                      </MenuItem>
                      <MenuItem value="DEPOSIT&" style={{ minWidth: "80px" }}>
                        Deposit
                      </MenuItem>
                      <MenuItem value="WITHDRAW&" style={{ minWidth: "80px" }}>
                        Withdraw
                      </MenuItem>
                    </Select>
                  </FormControl>
                </>
              )}
            </div>
          </div>
          {filterType == "Date" && (
            <div className=" flex">
              {" "}
              <MuiPickersUtilsProvider utils={DateFnsUtils} className="flex">
                <div className="mr-3">
                  <KeyboardDatePicker
                    disableToolbar
                    clearable
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="start"
                    label="Start"
                    classes={{
                      root: classes.rootSelect,
                    }}
                    className={classes.date}
                    value={fromDate}
                    onChange={handleFromDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    maxDate={new Date()}
                  />
                </div>
                <div>
                  <KeyboardDatePicker
                    disableToolbar
                    clearable
                    inputVariant="outlined"
                    className={classes.date}
                    InputProps={{ disableUnderline: true }}
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="end"
                    label="End"
                    value={toDate}
                    onChange={handleToDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    minDate={fromDate}
                    maxDate={new Date()}
                  />
                </div>
              </MuiPickersUtilsProvider>
            </div>
          )}
        </div>
        <div>
          <div>
            <div className="mb-5">
              <input
                type="text"
                className="bg-gray-300 dark:bg-gray-900 shadow-none border-none p-3 w-full dark:text-white rounded-md py-4"
                placeholder="Search Coins"
                value={searchText}
                onChange={onSearchMobile}
              ></input>
            </div>
            {isTransactionsAvailable && tradeHistory.content.length != 0 ? (
              tradeHistory.content.map((ele, idx) => (
                <>
                  <div>
                    <TransactionCard
                      coinIcons={coinIcons[ele.coin]}
                      key={ele.id}
                      coin={ele.coin}
                      quantity={ele.quantity}
                      tds={ele.tds}
                      price={ele.price}
                      totalAmount={ele.finalAmount}
                      type={ele.type}
                      side={ele.side}
                      createdAt={ele.createdAt}
                      updatedAt={ele.updatedAt}
                      status={ele.status}
                    ></TransactionCard>
                    <div
                      className={` ${
                        idx == tradeHistory.content.length - 1 && "hidden"
                      } `}
                      style={{ border: "1px solid #999" }}
                    ></div>
                  </div>
                </>
              ))
            ) : (
              <div className=" text-gray-500">
                <h2 className="font-light">No transactions found</h2>
              </div>
            )}{" "}
            {isTransactionsAvailable && tradeHistory.content.length != 0 && (
              <TablePagination
                classes={{ root: classes.rootPagination }}
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={tradeHistory ? tradeHistory.totalElements : 10}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Rows"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function ToggleSwitch(props) {
  const [selected, setSelected] = useState(props.selected);
  const handleChange = (val) => {
    setSelected(val);
    props.onChange(val);
  };

  const selectionStyle = () => {
    return {
      left: `${(props.values.indexOf(selected) / 2) * 100}%`,
    };
  };
  return (
    <Switch {...props}>
      {props.values.map((val) => {
        return (
          <span>
            <ConcealedRadio value={val} selected={selected} />
            <ClickableLabel title={val} onChange={handleChange} />
          </span>
        );
      })}
      <SwitchSelection style={selectionStyle()} darkMode={props.darkMode} />
    </Switch>
  );
}
const titleCase = (str) =>
  str
    .split(/\s+/)
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(" ");

const ClickableLabel = ({ title, onChange, id }) => (
  <SwitchLabel onClick={() => onChange(title)} className={id}>
    {titleCase(title)}
  </SwitchLabel>
);

const ConcealedRadio = ({ value, selected }) => (
  <SwitchRadio type="radio" name="switch" checked={selected === value} />
);

const Switch = styled.div`
  position: relative;
  height: 40px;
  width: 135px;

  color: ${(props) => (props.darkMode ? "#fff" : "#000")};
  background-color: ${(props) => (props.darkMode ? "#0F1421" : "#F1F1F1")};
  border-radius: 3px;
`;

const SwitchRadio = styled.input`
  display: none;
`;

const SwitchSelection = styled.span`
  display: block;
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
  width: 50%;
  height: 100%;
  background-color: ${(props) => (props.darkMode ? "#141C2E" : "#FDFDFD")};
  border-radius: 3px;
  transition: left 0.25s ease-out;
`;

const SwitchLabel = styled.label`
  position: relative;
  z-index: 2;
  float: left;
  width: 50%;
  // line-height: 26px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  ${SwitchRadio}:checked + & {
    transition: all 0.15s ease-out;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.08));
    border-bottom: 3px solid #3ac4ab;
  }
`;

const useStyles = makeStyles((theme) => ({
  // container: {
  //   flexGrow: 1,
  //   [theme.breakpoints.down("sm")]: {
  //     minWidth: "450px",
  //     maxWidth: "450px",
  //   },
  // },
  icon: {
    color: "#3AC4AB",
  },
  rootSelect: { fontSize: "12px", minWidth: "60px" },
  rootPagination: {
    overflow: "hidden",
    left: "0px",
    marginLeft: "-10px",
    display: "flex",
  },
  root: {
    // marginTop: theme.spacing(10),
    // marginLeft: theme.spacing(10),
    // alignItems: "left",
    [theme.breakpoints.down("sm")]: {
      // width: '90%',
      // marginTop: "20px",
      // maxWidth: "450px",
      // minWidth: "450px",
      // marginLeft: "25px",
      // marginRight: "25px",
    },
    // margin: "auto",
    marginBottom: "80px",
    // width: "95%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  // date: { width: "170px" },
  paddedContainer: {
    padding: "40px",
    background: theme.palette.type === "dark" ? "#151827" : "white",
    [theme.breakpoints.down("sm")]: { padding: "10px" },
  },
  table: {
    // marginTop: "20px",
  },
  headerCell: {
    background: theme.palette.type === "dark" ? "#151827" : "white",
    fontWeight: "bold",
  },
  filterContainer: {
    [theme.breakpoints.down("lg")]: {
      display: "flex",
      flexWrap: "wrap",
      margin: "10px 0px",

      // flexDirection: "column",
      // alignItems: "flex-start",
    },
    [theme.breakpoints.up("xl")]: {
      display: "flex",
      // flexDirection: "row",
      alignItems: "center",
    },
  },
  subContainer: {
    display: "flex",
    flexWrap: "wrap",
    margin: "10px 0px",

    flexDirection: "row",
    alignItems: "center",
    paddingBottom: "20px",
  },
  searchContainer: {
    [theme.breakpoints.down("lg")]: {
      marginRight: "10px",
      minWidth: "220px",
      margin: "10px 0px",
    },
    [theme.breakpoints.up("xl")]: {
      padding: "20px",
      minWidth: "220px",
    },
  },
  dropDownType: {
    fontSize: "10px",
    [theme.breakpoints.down("lg")]: {
      marginRight: "10px",
      // minWidth: "120px",
    },
    [theme.breakpoints.up("xl")]: {
      marginLeft: "24px",
      marginRight: "24px",
      minWidth: "120px",
    },
  },
  dropDownSide: {
    [theme.breakpoints.down("lg")]: {
      minWidth: "120px",
    },
    [theme.breakpoints.up("xl")]: {
      marginLeft: "24px",
      marginRight: "44px",
      minWidth: "120px",
    },
  },
  dateContainer: {
    [theme.breakpoints.down("lg")]: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
  },
  excelContainer: {
    [theme.breakpoints.down("lg")]: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%",
    },
  },
  excelButton: {
    color: "white",
    fontWeight: "bold",
    [theme.breakpoints.up("xl")]: {
      marginBottom: "20px",
      marginLeft: "44px",
    },
  },
  copyIcon: {
    fontSize: "20px",
    color: "#ffffff",
    "&:hover": {
      cursor: "pointer",
    },
  },
  tableRoot: {
    position: "relative",
    [theme.breakpoints.down("md")]: {
      "&:after": {
        content: "''",
        position: "absolute",
        zIndex: 1,
        top: "0",
        right: "0",
        bottom: "15px",
        pointerEvents: "none",
        backgroundImage:
          theme.palette.type === "dark"
            ? "linear-gradient(to right,rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1))"
            : "linear-gradient(to right, rgba(255, 255, 255, 0), #999 85%)",
        width: "15%",
      },
    },
  },
}));
